module.exports = __webpack_public_path__ + "img/7.2a4abe4b.webp";